import { render, staticRenderFns } from "./edit-customer-dialog.vue?vue&type=template&id=4996b73b&scoped=true"
import script from "./edit-customer-dialog.vue?vue&type=script&lang=js"
export * from "./edit-customer-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-customer-dialog.vue?vue&type=style&index=0&id=4996b73b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996b73b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4996b73b')) {
      api.createRecord('4996b73b', component.options)
    } else {
      api.reload('4996b73b', component.options)
    }
    module.hot.accept("./edit-customer-dialog.vue?vue&type=template&id=4996b73b&scoped=true", function () {
      api.rerender('4996b73b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/admin/edit-customer-dialog.vue"
export default component.exports